// 博客数据管理工具
class BlogData {
  constructor() {
    this.STORAGE_KEY = 'blog_posts';
    this.ARCHIVE_KEY = 'blog_archives';
    this.initData();
  }

  // 初始化数据
  initData() {
    if (!localStorage.getItem(this.STORAGE_KEY)) {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify([]));
    }
    if (!localStorage.getItem(this.ARCHIVE_KEY)) {
      localStorage.setItem(this.ARCHIVE_KEY, JSON.stringify([]));
    }
  }

  // 获取所有文章
  getAllPosts() {
    const posts = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
    return posts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  // 获取文章数量
  getPostCount() {
    const posts = this.getAllPosts();
    return posts.length;
  }

  // 创建新文章
  createPost(postData) {
    const posts = this.getAllPosts();
    const newPost = {
      id: Date.now(),
      ...postData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      viewCount: 0,
      likeCount: 0,
      commentCount: 0
    };
    
    posts.unshift(newPost);
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(posts));
    
    // 更新归档数据
    this.updateArchiveData();
    
    return newPost;
  }

  // 更新归档数据
  updateArchiveData() {
    const posts = this.getAllPosts();
    const archives = {};
    
    posts.forEach(post => {
      const date = new Date(post.createdAt);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始
      const key = `${year}-${month}`;
      
      if (!archives[key]) {
        archives[key] = {
          year,
          month,
          count: 0,
          posts: []
        };
      }
      
      archives[key].count++;
      archives[key].posts.push(post.id);
    });
    
    // 转换为数组并排序
    const archiveArray = Object.values(archives)
      .sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year;
        return b.month - a.month;
      });
    
    localStorage.setItem(this.ARCHIVE_KEY, JSON.stringify(archiveArray));
    
    // 发布数据更新事件
    window.dispatchEvent(new CustomEvent('blogDataUpdated'));
  }

  // 获取归档数据
  getArchives() {
    const archives = JSON.parse(localStorage.getItem(this.ARCHIVE_KEY) || '[]');
    return archives;
  }

  // 按月获取文章
  getPostsByYearMonth(year, month) {
    const posts = this.getAllPosts();
    return posts.filter(post => {
      const date = new Date(post.createdAt);
      return date.getFullYear() === year && 
             (date.getMonth() + 1) === month;
    });
  }

  // 获取统计数据
  getStats() {
    const posts = this.getAllPosts();
    const archives = this.getArchives();
    
    return {
      totalPosts: posts.length,
      totalViews: posts.reduce((sum, post) => sum + post.viewCount, 0),
      totalLikes: posts.reduce((sum, post) => sum + post.likeCount, 0),
      archiveCount: archives.length,
      categories: this.getCategories()
    };
  }

  // 获取分类统计
  getCategories() {
    const posts = this.getAllPosts();
    const categories = {};
    
    posts.forEach(post => {
      if (post.category) {
        if (!categories[post.category]) {
          categories[post.category] = 0;
        }
        categories[post.category]++;
      }
    });
    
    return Object.entries(categories).map(([name, count]) => ({
      name,
      count
    }));
  }

  // 添加示例数据（用于测试）
  addSampleData() {
    if (this.getPostCount() === 0) {
      const samplePosts = [
        {
          title: '欢迎来到我的博客',
          content: '# 欢迎\n\n这是我的第一篇博客文章，欢迎阅读！',
          summary: '这是博客的第一篇文章',
          author: '张三',
          tags: ['欢迎', '博客'],
          category: '生活随笔'
        },
        {
          title: 'React入门指南',
          content: '# React入门\n\n学习React的基本概念和用法',
          summary: 'React框架的入门教程',
          author: '张三',
          tags: ['React', '前端', 'JavaScript'],
          category: '前端开发'
        }
      ];
      
      samplePosts.forEach(post => {
        this.createPost(post);
      });
    }
  }
}

// 导出单例实例
export default new BlogData();